export function areSetsEqual<T>(setA: Set<T>, setB: Set<T>): boolean {
    if (setA.size != setB.size) return false;

    // we can someday use Set.difference() but it's too new
    for (const value of setA) {
        if (!setB.has(value)) return false;
    }
    return true;
}
